import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { allArticles } from '@/mocks/articles';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sugargoosheet.icu';

const articleImages: Record<string, string> = {
  'article-what-is-01': 'https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20a%20rich%20walnut%20wooden%20desk%20displaying%20colorful%20spreadsheet%20data%20charts%2C%20warm%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20cozy%20home%20office%20atmosphere%20with%20a%20small%20potted%20succulent%20plant%2C%20clean%20organized%20workspace%2C%20editorial%20photography%20with%20soft%20natural%20tones&width=1200&height=600&seq=art-whatis-v2-01&orientation=landscape',
  'article-best-finds-02': 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20trending%20fashion%20sneakers%20artfully%20arranged%20on%20a%20textured%20concrete%20floor%20with%20dramatic%20diagonal%20shadows%2C%20industrial%20loft%20aesthetic%20with%20exposed%20brick%20wall%20in%20background%2C%20street%20style%20editorial%20photography%2C%20bold%20urban%20energy&width=1200&height=600&seq=art-finds-v2-02&orientation=landscape',
  'article-safety-03': 'https://readdy.ai/api/search-image?query=Abstract%20representation%20of%20digital%20security%20with%20a%20glowing%20translucent%20shield%20hovering%20above%20a%20dark%20slate%20surface%2C%20subtle%20blue%20and%20green%20light%20reflections%2C%20modern%20tech%20aesthetic%2C%20minimalist%20cyber%20security%20concept%2C%20clean%20sophisticated%20composition&width=1200&height=600&seq=art-safety-v2-03&orientation=landscape',
  'article-shipping-04': 'https://readdy.ai/api/search-image?query=Stylized%20cardboard%20boxes%20of%20various%20sizes%20stacked%20artistically%20on%20a%20warm%20terracotta%20colored%20surface%2C%20soft%20directional%20lighting%20from%20a%20large%20window%2C%20logistic%20and%20delivery%20concept%20photography%2C%20modern%20e-commerce%20aesthetic%2C%20clean%20composition&width=1200&height=600&seq=art-shipping-v2-04&orientation=landscape',
  'article-coupon-05': 'https://readdy.ai/api/search-image?query=Elegant%20golden%20discount%20tags%20and%20ribbons%20scattered%20on%20a%20soft%20mint%20green%20velvet%20surface%2C%20warm%20ambient%20lighting%20with%20gentle%20sparkle%20highlights%2C%20luxury%20savings%20concept%2C%20refined%20editorial%20photography%2C%20fresh%20and%20inviting%20atmosphere&width=1200&height=600&seq=art-coupon-v2-05&orientation=landscape',
  'article-warehouse-06': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20warehouse%20interior%20with%20organized%20shelving%20units%20and%20soft%20overhead%20lighting%2C%20clean%20industrial%20aesthetic%20with%20warm%20wood%20accents%2C%20professional%20logistics%20environment%2C%20spacious%20and%20bright%20atmosphere%2C%20architectural%20photography%20style&width=1200&height=600&seq=art-warehouse-v2-06&orientation=landscape',
  'article-legit-07': 'https://readdy.ai/api/search-image?query=Hand%20holding%20a%20magnifying%20glass%20over%20a%20document%20with%20a%20checkmark%20symbol%2C%20soft%20natural%20lighting%20on%20a%20clean%20white%20desk%20surface%2C%20trust%20and%20verification%20concept%2C%20editorial%20business%20photography%2C%20warm%20and%20reassuring%20atmosphere&width=1200&height=600&seq=art-legit-v2-07&orientation=landscape',
  'article-tutorial-08': 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20step%20by%20step%20instructions%20next%20to%20a%20modern%20tablet%20device%2C%20soft%20morning%20light%20on%20a%20light%20oak%20desk%2C%20learning%20and%20education%20concept%2C%20minimalist%20stationery%20aesthetic%2C%20warm%20inviting%20study%20atmosphere&width=1200&height=600&seq=art-tutorial-v2-08&orientation=landscape',
  'article-comparison-09': 'https://readdy.ai/api/search-image?query=Two%20contrasting%20objects%20side%20by%20side%20on%20a%20split%20background%20of%20warm%20coral%20and%20cool%20sage%20green%2C%20balanced%20comparison%20concept%2C%20modern%20minimalist%20product%20photography%2C%20clean%20geometric%20composition%2C%20soft%20diffused%20lighting&width=1200&height=600&seq=art-comparison-v2-09&orientation=landscape',
  'article-shoes-10': 'https://readdy.ai/api/search-image?query=Single%20premium%20sneaker%20dramatically%20spotlighted%20on%20a%20dark%20charcoal%20pedestal%20with%20subtle%20colored%20rim%20lighting%2C%20high%20contrast%20luxury%20product%20photography%2C%20gallery%20exhibition%20style%20presentation%2C%20bold%20artistic%20composition%2C%20exquisite%20detail&width=1200&height=600&seq=art-shoes-v2-10&orientation=landscape',
  'article-clothing-11': 'https://readdy.ai/api/search-image?query=Fashionable%20streetwear%20outfit%20elegantly%20displayed%20on%20a%20minimalist%20clothing%20rack%20against%20a%20soft%20butter%20yellow%20wall%2C%20warm%20afternoon%20light%20casting%20gentle%20shadows%2C%20boutique%20store%20aesthetic%2C%20editorial%20fashion%20photography%2C%20relaxed%20sophisticated%20vibe&width=1200&height=600&seq=art-clothing-v2-11&orientation=landscape',
  'article-accessories-12': 'https://readdy.ai/api/search-image?query=Assorted%20premium%20lifestyle%20accessories%20including%20a%20watch%20and%20leather%20goods%20arranged%20on%20a%20navy%20blue%20linen%20surface%2C%20warm%20brass%20accent%20lighting%2C%20luxury%20still%20life%20photography%2C%20refined%20sophisticated%20composition%2C%20rich%20textures%20and%20reflections&width=1200&height=600&seq=art-accessories-v2-12&orientation=landscape',
};

function buildArticleJsonLd(article: typeof allArticles[0]) {
  const articleUrl = `${siteUrl}/blog/${article.slug}`;
  const imageUrl = articleImages[article.imageSeq] || '';
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    '@id': `${articleUrl}#article`,
    headline: article.title,
    description: article.excerpt,
    url: articleUrl,
    datePublished: article.date,
    dateModified: article.date,
    author: {
      '@type': 'Organization',
      name: 'Sugargoo Spreadsheet',
      url: `${siteUrl}/`,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Sugargoo Spreadsheet',
      url: `${siteUrl}/`,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
      },
    },
    image: imageUrl
      ? {
          '@type': 'ImageObject',
          url: imageUrl,
        }
      : undefined,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${articleUrl}#webpage`,
    },
    isPartOf: {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      name: 'Sugargoo Spreadsheet',
      url: `${siteUrl}/`,
    },
    about: {
      '@type': 'Thing',
      name: 'Sugargoo Spreadsheet',
    },
    articleSection: article.tags ? article.tags[0] : 'Sugargoo Spreadsheet',
    inLanguage: 'en',
    wordCount: article.content ? article.content.split(' ').length : 0,
    keywords: article.tags ? article.tags.join(', ') : 'Sugargoo Spreadsheet',
  };
}

function renderContent(content: string) {
  const lines = content.split('\n');
  const elements: JSX.Element[] = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];

    if (line.startsWith('## ')) {
      elements.push(
        <h2 key={i} className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mt-10 mb-4">
          {line.replace('## ', '')}
        </h2>
      );
      i++;
    } else if (line.startsWith('### ')) {
      elements.push(
        <h3 key={i} className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mt-8 mb-3">
          {line.replace('### ', '')}
        </h3>
      );
      i++;
    } else if (line.trim() === '') {
      i++;
    } else {
      elements.push(
        <p key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
          {line}
        </p>
      );
      i++;
    }
  }

  return elements;
}

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const article = allArticles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-20">
          <section className="w-full px-4 md:px-6 py-20 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">Article Not Found</h1>
            <p className="text-sm text-foreground-600 mb-6">The article you are looking for does not exist.</p>
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Back to Guides
            </Link>
          </section>
        </main>
        <Footer />
      </>
    );
  }

  const articleJsonLd = buildArticleJsonLd(article);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
      />
      <Navbar />
      <main className="pt-20">
        <article>
          <header className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-2 text-xs text-foreground-500 mb-4">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">
                  Home
                </Link>
                <span>/</span>
                <Link to="/blog" className="hover:text-primary-500 transition-colors cursor-pointer">
                  Shopping Guide
                </Link>
                <span>/</span>
                <span className="text-foreground-400 line-clamp-1">{article.title}</span>
              </div>

              <div className="flex flex-wrap gap-2 mb-5">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-5">
                {article.title}
              </h1>

              <div className="flex items-center gap-4 text-xs text-foreground-500 mb-6">
                <span>{article.date}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                <span>{article.readTime} read</span>
              </div>

              <div className="relative w-full aspect-[2/1] rounded-lg overflow-hidden mb-8">
                <img
                  src={articleImages[article.imageSeq] || articleImages['article-what-is-01']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 p-4 rounded-lg bg-accent-50 border border-accent-200/50">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-accent-600 text-lg"></i>
                </div>
                <p className="text-xs text-accent-800 leading-relaxed">
                  <strong>Disclaimer:</strong> This is an independent educational platform. We are not affiliated with or endorsed by Sugargoo. The information provided is for educational purposes only. Always verify details on the official Sugargoo platform before making purchases.
                </p>
              </div>
            </div>
          </header>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
            <div className="max-w-3xl mx-auto">
              <div className="prose-custom">
                {renderContent(article.content)}
              </div>

              <div className="mt-12 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  Ready to Start Shopping?
                </h3>
                <p className="text-sm text-foreground-600 mb-4">
                  Explore the best Sugargoo spreadsheet finds on our main platform. Browse curated products across all categories.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Visit Sugargoo Spreadsheet
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-up-line text-sm"></i>
                    </div>
                  </a>
                  <Link
                    to="/blog"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    More Guides
                  </Link>
                </div>
              </div>

              <div className="mt-8 flex items-center justify-between">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-left-line text-sm"></i>
                  </div>
                  Back to Home
                </Link>
                <Link
                  to="/blog"
                  className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  All Guides
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </Link>
              </div>
            </div>
          </section>
        </article>
      </main>
      <Footer />
    </>
  );
}